import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${colors.fontPrimary};

  &[data-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid ${colors.borderGrey};
  border-radius: 50%;
  margin: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;

  &:checked {
    border-color: ${colors.fontPrimary};
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${colors.fontPrimary};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
